import React from 'react';
import { ProjectComponent } from 'components/Project';
import { useParams } from 'react-router-dom';
import { TabbedProjectPage } from 'components/TabbedProjectPage';

export const ProjectPage = () => {
  const { id } = useParams<{ id: string }>();
  if (true) {
    return <TabbedProjectPage id={Number(id || 0)} template={false} />;
  } else {
    return <ProjectComponent id={Number(id || 0)} template={false} />;
  }
};
